import React from 'react'
import { Helmet } from 'react-helmet'
import PropTypes from 'prop-types'
import { useLocation } from '@reach/router'
import { useStaticQuery, graphql } from 'gatsby'

const SEO = ({ article, seoData }) => {
	const { pathname } = useLocation()
	const { site } = useStaticQuery(query)
	const { defaultTitle, defaultDescription, defaultDescriptionEn, siteUrl, defaultImage } = site.siteMetadata
	const seo = {
		title: seoData?.title || defaultTitle,
		description: seoData?.description || pathname.includes('/en/') ? defaultDescriptionEn : defaultDescription,
		image: `${siteUrl}${seoData?.opengraphImage?.localFile?.publicURL || defaultImage}`,
		url: `${siteUrl}${pathname}`,
	}

	return (
		<Helmet title={seo.title}>
			<meta name='description' content={seo.description} />
			<meta name='image' content={seo.image} />
			{seo.url && <meta property='og:url' content={seo.url} />}
			{!!article && <meta property='og:type' content='article' />}
			{seo.title && <meta property='og:title' content={seo.title} />}
			{seo.description && <meta property='og:description' content={seo.description} />}
			{seo.image && <meta property='og:image' content={seo.image} />}

			<meta name='twitter:card' content='summary_large_image' />
			{seo.title && <meta name='twitter:title' content={seo.title} />}
			{seo.description && <meta name='twitter:description' content={seo.description} />}
			{seo.image && <meta name='twitter:image' content={seo.image} />}

			{process.env.EMF_ENV === 'production' && (
				<script id='usercentrics-cmp' src='https://web.cmp.usercentrics.eu/ui/loader.js' data-ruleset-id='hBa61yem0SBzrn' data-language='language' async></script>
			)}
			{process.env.EMF_ENV === 'staging' && (
				<script id='usercentrics-cmp' src='https://web.cmp.usercentrics.eu/ui/loader.js' data-draft='true' data-ruleset-id='hBa61yem0SBzrn' data-language='language' async></script>
			)}

			<script>
				{`window.addEventListener('UC_CONSENT', function(e) {
          if (e.detail.services.BJ59EidsWQ.consent.given === true) {
            (function(w, d, s, l, i) {
              w[l] = w[l] || [];
              w[l].push({ 'gtm.start': new Date().getTime(), event: 'gtm.js' });
              var f = d.getElementsByTagName(s)[0],
                  j = d.createElement(s),
                  dl = l !== 'dataLayer' ? '&l=' + l : '';
              j.async = true;
              j.src = 'https://www.googletagmanager.com/gtm.js?id=' + i + dl;
              f.parentNode.insertBefore(j, f);
            })(window, document, 'script', 'dataLayer', 'GTM-T94SDMK'); 

          }
        });`}
			</script>
		</Helmet>
	)
}
export default SEO

SEO.propTypes = {
	title: PropTypes.string,
	description: PropTypes.string,
	image: PropTypes.string,
	article: PropTypes.bool,
}
SEO.defaultProps = {
	title: null,
	description: null,
	image: null,
	article: false,
}

const query = graphql`
	query SEO {
		site {
			siteMetadata {
				defaultTitle: title
				siteUrl
				defaultDescription: description
				defaultDescriptionEn: descriptionEn
				defaultImage: image
			}
		}
	}
`
